import { Col, Row } from "antd";
import NumberAdsByCategory from "./Components/NumberAdsByCategory";
import AdPublicationPeriod from "./Components/AdPublicationPeriod";
import Last30DaysAvrage from "./Components/30DaysAvrage";
import UnReadMessages from "./Components/UnReadMesages";
import MessageResponseTime from "./Components/MessageResponseTime";
import TopFilters from "./Components/TopFilters";
import PageTitle from "apps/Common/PageTitle";
import MobileTopFilters from "./Components/MobileTopFilters";

const CompetitorAnalysisIndex = () => {
  return (
    <>
      <Col span={24} className="!mt-4 !mb-12 ">
        <Row gutter={[40, 40]}>
          
          <Col xs={24} className="!hidden md:!block">
            <TopFilters isMobile={false} />
          </Col>
          <Col xs={24} className="!block md:!hidden">
            <MobileTopFilters />
          </Col>

          <Col xs={24} xxl={12}>
            <NumberAdsByCategory />
          </Col>
        
          <Col xs={24} lg={12}>
            <Last30DaysAvrage />
          </Col>
          <Col xs={24} md={12} lg={8}>
            <UnReadMessages />
          </Col>
          <Col xs={24} md={12} lg={8}>
            <AdPublicationPeriod />
          </Col>

          <Col xs={24} md={12} lg={8}>
            <MessageResponseTime />
          </Col>
        </Row>
      </Col>
    </>
  );
};

export default CompetitorAnalysisIndex;
